import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint, Sine } from 'gsap';

@Component({
	selector: 'app-security-check-registration',
	templateUrl: './security-check-registration.component.html',
	styleUrls: ['./security-check-registration.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SecurityCheckRegistrationComponent implements OnInit {
	view = '[data-component="security-check-registration"]';
	loading = false;

	constructor() { }

	ngOnInit() {

			AppEventDispatcher.listen(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INIT, (data: any) => {
				TweenMax.to('[data-component="login"]', .8, { width: '100%', height: 500, ease: Sine.easeOut});
				TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

				TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});

				AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INFO, { show: true });
			});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/security-check-registration/security-check-registration.component.ts